import { MENU_AUTH } from './menusAuth';

export const OPT_ADD = 'add';
export const OPT_EDIT = 'edit';
export const OPT_DETAIL = 'detail';
export const OPT_TYPE = {
  [OPT_ADD]: {
    title: '添加',
    opt: 'add',
  },
  [OPT_EDIT]: {
    title: '编辑',
    opt: 'edit',
  },
  [OPT_DETAIL]: {
    title: '详情',
    opt: 'detail',
  },
};

export const LANG_MAP = {
  default: 'cn',
  cn: 'cn',
  en: 'en',
};

export const brandCodeMap = {
  default: 'ecco',
  ecco: 'ecco',
  'abi-jd': 'abi-jd',
  'abi-bud': 'abi-bud',
  'abi-hrb': 'abi-hrb',
  hrb: 'hrb',
  bxc: 'bxc',
  bud: 'bud',
};
export const BRAND = {
  10011: 'abi-jd',
  10001: 'hrb',
  10002: 'bxc',
  10003: 'bud',
  10004: 'abi-bud',
  10005: 'abi-hrb',
  10006: 'ecco',
};
export const APP_ID = {
  monitor: '10002',
  loyalty: '159904',
};

export const BARND_ID = {
  bud: '10001',
  brd: '10002',
};

export const sexMap = {
  F: '女',
  M: '男',
  U: '未知',
};
export const sexMapList = [
  { id: 'U', name: '未知' },
  { id: 'M', name: '男' },
  { id: 'F', name: '女' },
];
export const sexMapListTw = [
  { id: 'M', name: '男' },
  { id: 'F', name: '女' },
];
export const integralTypeList = [
  { id: 'ADD', name: '增加' },
  { id: 'SUB', name: '减少' },
];
export const industryList = [
  { id: '1', name: '金融业' },
  { id: '2', name: '房地产业' },
  { id: '3', name: '住宿和餐饮业' },
  { id: '4', name: '交通运输' },
  { id: '6', name: '医药卫生' },
  { id: '7', name: '信息产业' },
  { id: '8', name: '机构组织' },
  { id: '9', name: '媒体' },
  { id: '10', name: '其他' },
];
export const professionalList = [
  { id: '1', name: '职员' },
  { id: '2', name: '学生' },
  { id: '3', name: '全职辣妈' },
  { id: '4', name: '自有公司' },
  { id: '5', name: '自由职业' },
  { id: '6', name: '其他' },
];
//行业、
export const maritalStatusList = [
  { id: '1', name: '单身' },
  { id: '2', name: '未婚有伴侣' },
  { id: '3', name: '已婚尚未有孩子' },
  { id: '4', name: '已婚有1个孩子' },
  { id: '5', name: '已婚有2个孩子或更多' },
];
// 入会渠道
export const channelMap = {
  TMALL: '天猫',
  MINIPROGRAM: '小程序',
  STORE: '门店',
  JD: '京东',
  WEBSITE: '官网',
  DOUYIN: '抖音',
  VIPSHOP: '唯品会',
  KAOLA: '考拉',
  VIPSHOP_CRM: '唯品会',
  PRIVATEPROGRAM: '私域小程序',
};
export const channelTWMap = {
  LINE: 'LINE',
  STORE: '门店',
};
// 入会渠道
export const channelMapList = [
  { id: 'STORE', name: '门店' },
  { id: 'MINIPROGRAM', name: '小程序' },
  { id: 'TMALL', name: '天猫' },
  { id: 'JD', name: '京东' },
  { id: 'WEBSITE', name: '官网' },
  { id: 'DOUYIN', name: '抖音' },
  { id: 'VIPSHOP', name: '唯品会' },
  { id: 'KAOLA', name: '考拉' },
  { id: 'PRIVATEPROGRAM', name: '私域小程序' },
];
export const channelTWMapList = [
  { id: 'STORE', name: '门店' },
  { id: 'LINE', name: 'LINE' },
];
// 订单来源
export const orderSourceMapList = [
  { id: 'STORE', name: '门店' },
  { id: 'MINIPROGRAM', name: '小程序' },
  { id: 'TMALL', name: '天猫' },
  { id: 'JD', name: '京东' },
  { id: 'WEBSITE', name: '官网' },
  { id: 'DOUYIN', name: '抖音' },
  { id: 'VIPSHOP', name: '唯品会' },
  { id: 'VIPSHOP_CRM', name: '唯品会_CRM' },
  { id: 'KAOLA', name: '考拉' },
  { id: 'PRIVATEPROGRAM', name: '私域小程序' },
];
export const orderSourceTWMapList = [
  { id: 'STORE', name: '门店' },
  { id: 'LINE', name: 'LINE' },
];
// 会员等级（百威）
export const gradeBudMap = {
  普卡会员: '普卡会员',
  银卡会员: '银卡会员',
  金卡会员: '金卡会员',
  钻石会员: '钻石会员',
};
// 会员等级（哈啤）
export const gradeHrbMap = {
  普卡会员: '普通会员',
  'VIP 会员': 'VIP 会员',
  尊享会员: '尊享会员',
  钻石会员: '钻石会员',
  至尊会员: '至尊会员',
};
// 身份类型
export const identityTypeMap = {
  1: '手机号',
  2: '淘宝',
  3: '微信 openID',
  4: '微信 unionID',
  5: '支付宝',
  6: '京东',
};
// 绑定类型
export const bindTypeMap = {
  BIND: '绑定',
  UNBIND: '解绑',
};
// 交易类型
export const discountTypeMap = {
  REDEMPTION_ORDER: '兑礼单',
  SALE_ORDER: '正单',
  REFUND_RETURN: '退单',
  REFUND_REMAIN: '退单',
};
//规则包状态
export const ruleStatusMap = {
  ENABLE: '启用',
  // INDETERMINATE: '不确定',
  DISABLE: '禁止',
};
//规则包状态
export const fieldPackageStatus = {
  ENABLE: '启用',
  // INDETERMINATE: '不确定',
  DISABLE: '禁止',
};
// 字段包
export const fieldPackageStatus2 = {
  ENABLE: '启用',
  // INDETERMINATE: '不确定',
  DISABLE: '禁止',
};
//输出项类型
export const outputTypeMap = {
  CONSTANT: '常量',
  VARIABLE: '变量',
};
//版本状态
export const versionStatus = {
  NOTONLINE: '未上线',
  RUNNING: '运行中',
  DOWNLINE: '已下线',
};
//审批状态
export const approvalStatus = {
  PENDING_APPLICATION: '待申请',
  PENDING_APPROVAL: '待审批',
  ADOPT: '通过',
  REJECT: '拒绝',
};
export const approvalStatusWithoutApproval = {
  PENDING_APPROVAL: '待审批',
  ADOPT: '通过',
  REJECT: '拒绝',
};
//当前操作
export const currentOperation = {
  APPLICATION_RELEASE: '申请发布',
  VERSION_ROLLBACK: '版本回滚',
};
//条件类型
export const conditionTypeMap = {
  EXTERNAL_INPUT: '外部入参',
  FIELD: '系统条件',
};
//多条件类型

export const conditionTypeTwoMap = {
  EXTERNAL_INPUT: '外部入参',
  FIELD: '系统条件',
  COMBINE: '组别',
};
//运算符
export const conditionMathMap = {
  GTE: '大于等于',
  LTE: '小于等于',
  GT: '大于',
  LT: '小于',
  EQ: '等于',
  NEQ: '不等于',
  IN: '属于',
  CONTAINS: '包含',
  MATCH: '匹配',
};
//逻辑运算符
export const logicalOperatorMap = {
  AND: '且',
  OR: '或',
};
//当前操作
export const fieldType = {
  STRING: 'string',
  INTEGER: 'int',
  DECIMAL: 'decimal',
};
//变量条件类型
export const tvfRuleTypeMap = {
  SYSTEM: '系统变量',
  TEMPORARY: '组别',
};
//变量运算符
export const tvfMathTypeMap = {
  ADDITION: '加',
  SUBTRACT: '减',
  MULTIPLICATION: '乘',
  REMAINDER: '取模',
  EXPONENTIATION: '非',
};
// 优惠券类型
export const COUPONTYPE = [
  { name: '折扣券', value: 'DISCOUNT_COUPON' },
  { name: '代金券', value: 'CASH_COUPON' },
  { name: '团购券', value: 'GROUP_COUPON' },
  { name: '兑换券', value: 'EXCHANGE_COUPON' },
];
// 优惠券状态
export const COUPONSTATUS = [
  { name: '失效', value: 'INVALID' },
  { name: '未领取', value: 'NOT_RECEIVED' },
  { name: '已领取', value: 'RECEIVED' },
  { name: '已核销', value: 'CONSUMED' },
  { name: '转赠中', value: 'RANSFERRING' },
  { name: '转赠退回', value: 'DONATION_RETURN' },
  { name: '已过期', value: 'EXPIRED' },
  { name: '冻结', value: 'FREEZE' },
  { name: '解冻', value: ':NOT_FREEZE' },
];

export const CAMPAIGNTYPE = [
  { name: '自定义人群', value: 'CUSTOM_CROWD' },
  { name: '指定手机号', value: 'ASSIGN_TELEPHONE' },
  { name: '注册未支付客户', value: 'REGISTERED_UNPAID' },
  { name: '重点召回客户', value: 'KEY_RECALL' },
];

export const OPERATESTATUS = [
  { name: '待审核', value: 'UNAPPROVED' },
  { name: '未开始', value: 'NOT_START' },
  { name: '进行中', value: 'UNDER_WAY' },
  { name: '已暂停', value: 'PAUSED' },
  { name: '已终止', value: 'TERMINATE' },
  { name: '已结束', value: 'COMPLETE' },
];

//模板类型
export const TEMPLATETYPE = [
  { name: '注册', value: 'REGISTRATION' },
  { name: '生日', value: 'BIRTHDAY' },
  { name: '节日活动', value: 'ACTIVITY_FESTIVAL' },
  { name: '会员日', value: 'MEMBER' },
  { name: '人群运营', value: 'ACTIVITY_GROUP' },
];

// 菜单区分
export const PANEL_DIST = {
  wpp: 'wpp', // 微信平台
  pmp: 'pmp', // 消息推送
  radp: 'radp', // unknown
  userAdmin: 'userAdmin', // 用户管理
};
export const SMS_TYPE = [
  {
    dictCode: 'VERIFICATION',
    dictValue: 0,
    nameZh: '验证码',
    nameEn: 'VERIFICATION',
    dictGroup: 'SMS_TYPE',
  },
  {
    dictCode: 'NOTIFICATION',
    dictValue: 1,
    nameZh: '短信通知',
    nameEn: 'NOTIFICATION',
    dictGroup: 'SMS_TYPE',
  },
  {
    dictCode: 'PROMOTION',
    dictValue: 2,
    nameZh: '推广短信',
    nameEn: 'PROMOTION',
    dictGroup: 'SMS_TYPE',
  },
];
export const SMS_APPROVE_STATUS = [
  {
    dictCode: 'APPROVING',
    dictValue: 0,
    nameZh: '审核中',
    nameEn: 'APPROVING',
    dictGroup: 'SMS_APPROVE_STATUS',
  },
  {
    dictCode: 'PASS',
    dictValue: 1,
    nameZh: '审核通过',
    nameEn: 'PASS',
    dictGroup: 'SMS_APPROVE_STATUS',
  },
  {
    dictCode: 'FAILD',
    dictValue: 2,
    nameZh: '审核失败',
    nameEn: 'FAILD',
    dictGroup: 'SMS_APPROVE_STATUS',
  },
];
export const COUPON_SOURCE_TYPE = [
  {
    dictCode: 'EXCHANGE',
    dictValue: 1,
    nameZh: '兑换 ',
    nameEn: 'EXCHANGE',
    dictGroup: 'COUPON_SOURCE_TYPE',
    sort: 1,
    remark: '兑换 ',
  },
  {
    dictCode: 'REGISTRATION_GIFT',
    dictValue: 2,
    nameZh: '注册赠送',
    nameEn: 'REGISTRATION_GIFT',
    dictGroup: 'COUPON_SOURCE_TYPE',
    sort: 2,
    remark: '注册赠送',
  },
  {
    dictCode: 'MEMBER_UPGRADE',
    dictValue: 3,
    nameZh: '会员升级',
    nameEn: 'MEMBER_UPGRADE',
    dictGroup: 'COUPON_SOURCE_TYPE',
    sort: 3,
    remark: '会员升级',
  },
  {
    dictCode: 'BIRTHDAY_GIFT',
    dictValue: 4,
    nameZh: '生日赠送',
    nameEn: 'BIRTHDAY_GIFT',
    dictGroup: 'COUPON_SOURCE_TYPE',
    sort: 4,
    remark: '生日赠送',
  },
  {
    dictCode: 'TARGETED_DELIVERY',
    dictValue: 5,
    nameZh: '定向投放',
    nameEn: 'TARGETED_DELIVERY',
    dictGroup: 'COUPON_SOURCE_TYPE',
    sort: 5,
    remark: '定向投放',
  },
  {
    dictCode: 'EVENT_GIFT',
    dictValue: 6,
    nameZh: '活动送券',
    nameEn: 'EVENT_GIFT',
    dictGroup: 'COUPON_SOURCE_TYPE',
    sort: 6,
    remark: '活动送券',
  },
];

export const COUPON_STATUS = [
  { name: '失效', value: 'INVALID' },
  { name: '未领取', value: 'NOT_RECEIVED' },
  { name: '已领取', value: 'RECEIVED' },
  { name: '已核销', value: 'CONSUMED' },
  { name: '已转赠', value: 'DONATED' },
  { name: '转赠中', value: 'TRANSFERRING' },
  { name: '转赠退回', value: 'DONATION_RETURN' },
  { name: '已过期', value: 'EXPIRED' },
  { name: '冻结', value: 'FREEZE' },
  { name: '解冻', value: 'NOT_FREEZE' },
];

export const ACTIVITYTENANTIDS = ['6679'];
//场景营销允许使用配置订阅消息模板
export const SUBACTIVITYTENANTIDS = ['6679', '4678'];
//场景营销允许使用配置订阅消息模板Appid
export const SUBACTIVITYTENANTIDSAPPIDS = {
  6679: 'wx1de90b80b9ec8ff3',
  4678: 'wx5c8e5633552559b2',
};

export const vipDataMap = new Map([
  ['6679', '大连'],
  ['3083', '长沙'],
  ['3680', '济南'],
]);
export const VS_ORDER_PRICE_TYPE_INIT = [
  {
    label: '普通票订单',
    value: 'ORDINARY',
  },
  {
    label: '学生票订单',
    value: 'STUDENT',
  },
];

export const TICKET_CHANGE_ORDER_STATUS_INIT = [
  {
    label: '普通单',
    value: 'UN_CHANGE',
  },
  {
    label: '已改签',
    value: 'TICKET_CHANGE',
  },
  {
    label: '部分改签',
    value: 'PARTIAL_TICKET_CHANGE',
  },
  {
    label: '改签单',
    value: 'CHANGED_NEW_TICKET',
  },
];
// 会员编码规则
export const MEMBER_CODE_RULE = ['000', '011079'];

//用户数据关于
export const DEFAULT_PERMITTEDGROUP = '159932';

// 新的菜单配置
export const NEW_MENU_CONFIG = [
  {
    title: '台上见小程序前端管理', // 台上见小程序前端管理
    href: '/smg',
    auth: MENU_AUTH.MENU_SMG,
    firstNav: true,
    items: [
      {
        title: '点位管理', // 点位管理
        href: '/smg/venue',
        auth: MENU_AUTH.MENU_SMG_VENUE,
        items: [
          {
            title: '轮播图管理', // 轮播图管理
            externalHref: 'mini-app/carousel-image-management',
            href: '',
            auth: MENU_AUTH.MENU_SMG_VENUE_BANNER,
          },
          {
            title: '热门推荐管理', // 热门推荐管理
            externalHref: 'mini-app/hot-recommendation-management',
            href: '',
            auth: MENU_AUTH.MENU_SMG_VENUE_HOT,
          },
          {
            title: '新剧推荐管理', // 新剧推荐管理
            externalHref: 'mini-app/new-repertoire-recommendation-management',
            href: '',
            auth: MENU_AUTH.MENU_SMG_VENUE_NEW,
          },
          {
            title: '剧场集合页', // 剧场集合页
            externalHref: 'mini-app/theatre',
            href: '',
            auth: MENU_AUTH.MENU_SMG_VENUE_THEATER,
          },
          {
            title: '开屏弹窗管理', // 开屏弹窗管理
            externalHref: 'mini-app/start-up-modal-controller',
            href: '',
            auth: MENU_AUTH.MENU_SMG_VENUE_SPLASH,
          },
          {
            title: '全屏广告', // 全屏广告
            externalHref: 'mini-app/splash-ad',
            href: '',
            auth: MENU_AUTH.MENU_SMG_VENUE_SPLASH_AD,
          },
          {
            title: 'Path字典', // Path字典
            isDev: true,
            href: '/smg/venue/path',
            auth: MENU_AUTH.MENU_SMG_VENUE_PATH,
          },
        ],
      },
      {
        title: '剧目管理', // 剧目管理
        href: '/smg/show',
        auth: MENU_AUTH.MENU_SMG_SHOW,
        items: [
          {
            title: '剧目列表', // 剧目列表
            externalHref: 'repertoire/list',
            href: '',
            auth: MENU_AUTH.MENU_SMG_SHOW_LIST,
          },
          {
            title: '剧目导入', // 剧目导入
            externalHref: 'repertoire/export',
            href: '',
            auth: MENU_AUTH.MENU_SMG_SHOW_IMPORT,
          },
          {
            title: '非台上见小程序票根', // 非台上见小程序票根
            externalHref: 'repertoire/third-ticket',
            href: '',
            auth: MENU_AUTH.MENU_SMG_SHOW_TICKET,
          },
        ],
      },
      {
        title: '业态管理', // 业态管理
        isDev: true,
        href: '/smg/biz',
        auth: MENU_AUTH.MENU_SMG_BIZ,
      },
      {
        title: '商城管理', // 商城管理
        href: '/smg/mall',
        auth: MENU_AUTH.MENU_SMG_MALL,
        items: [
          {
            title: '商品管理', // 商品管理
            href: '/integral/gift_management', // 原链接 integral/gift_management
            auth: MENU_AUTH.MENU_SMG_MALL_GOODS,
            isChild: true,
            items: [
              {
                title: '新建礼品',
                href: '/integral/gift_management/management_gift_form_add',
                isHide: true,
              },
              {
                title: '编辑礼品',
                href: '/integral/gift_management/management_gift_form_edit',
                isHide: true,
              },
              {
                title: '礼品详情',
                href: '/integral/gift_management/management_gift_form_detail',
                isHide: true,
              },
            ],
          },
          {
            title: '货架管理', // 货架管理
            href: '/integral/goods_shelf_management', // 原链接 integral/goods_shelf_management
            auth: MENU_AUTH.MENU_SMG_MALL_SHELF,
            isChild: true,
            items: [
              {
                title: '新建货架',
                href: '/integral/goods_shelf_management/management_goods_shelf_form_add',
                isHide: true,
              },
              {
                title: '编辑货架',
                href: '/integral/goods_shelf_management/management_goods_shelf_form_edit',
                isHide: true,
              },
              {
                title: '货架详情',
                href: '/integral/goods_shelf_management/management_goods_shelf_form_detail',
                isHide: true,
              },
              {
                title: '小程序码',
                href: '/integral/goods_shelf_management/qr_code',
                isHide: true,
              },
            ],
          },
          {
            title: '礼品兑换记录', // 礼品兑换记录
            href: '/integral/gift_exchange_record', // 原链接 integral/gift_exchange_record
            auth: MENU_AUTH.MENU_SMG_MALL_EXCHANGE,
            isChild: true,
            items: [
              {
                title: '礼品兑换记录编辑',
                href: '/integral/gift_exchange_record/gift_exchange_record_form_edit',
                isHide: true,
              },
              {
                title: '礼品兑换记录详情',
                href: '/integral/gift_exchange_record/gift_exchange_record_form_detail',
                isHide: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: '平台数据分析', // 平台数据分析
    href: '/platform',
    auth: MENU_AUTH.MENU_PLATFORM,
    firstNav: true,
    items: [
      {
        title: '访问规模', // 访问规模
        href: '/platform/visits',
        auth: MENU_AUTH.MENU_PLATFORM_VISITS,
        items: [
          {
            title: '访问入口分析', // 访问入口分析
            isDev: true,
            href: '/platform/visits/entry',
            auth: MENU_AUTH.MENU_PLATFORM_VISITS_ENTRY,
          },
        ],
      },
      {
        title: '小程序页面热度', // 小程序页面热度
        href: '/platform/page_heat',
        auth: MENU_AUTH.MENU_PLATFORM_PAGE_HEAT,
        items: [
          {
            title: '小程序页面TOP5', // 小程序页面TOP5
            isDev: true,
            href: '/platform/page_heat/top5',
            auth: MENU_AUTH.MENU_PLATFORM_PAGE_HEAT_TOP5,
          },
          {
            title: '访问路径管理', // 访问路径管理
            isDev: true,
            href: '/platform/page_heat/path',
            auth: MENU_AUTH.MENU_PLATFORM_PAGE_HEAT_PATH,
          },
        ],
      },
      {
        title: '访问入口分析', // 访问入口分析
        href: '/platform/entry',
        auth: MENU_AUTH.MENU_PLATFORM_ENTRY,
        items: [
          {
            title: '场景值访问情况', // 场景值访问情况
            isDev: true,
            href: '/platform/entry/scene',
            auth: MENU_AUTH.MENU_PLATFORM_ENTRY_SCENE,
          },
        ],
      },
    ],
  },
  {
    title: '销售分析', // 销售分析
    href: '/sales',
    auth: MENU_AUTH.MENU_SALES,
    firstNav: true,
    items: [
      {
        title: '票房看板', // 票房看板
        href: '/sales/board',
        auth: MENU_AUTH.MENU_SALES_BOARD,
        items: [
          {
            title: '实时平台总票房', // 实时平台总票房
            // href: '/sales/board/realtime',
            href: '/report/bhc',
            auth: MENU_AUTH.MENU_SALES_BOARD_REALTIME,
          },
          {
            title: '单一剧目票房管理', // 单一剧目票房管理
            // href: '/sales/board/show',
            href: '/report/perform_sales',
            auth: MENU_AUTH.MENU_SALES_BOARD_SHOW,
          },
          {
            title: '渠道分析', // 渠道分析
            isDev: true,
            href: '/sales/board/channel',
            auth: MENU_AUTH.MENU_SALES_BOARD_CHANNEL,
          },
          {
            title: '报表中心', // 报表中心
            isDev: true,
            href: '/sales/board/report',
            auth: MENU_AUTH.MENU_SALES_BOARD_REPORT,
          },
        ],
      },
      {
        title: '订单管理', // 订单管理
        href: '/sales/orders',
        auth: MENU_AUTH.MENU_SALES_ORDERS,
        items: [
          {
            title: '台上见订单查询', // 台上见订单查询
            externalHref: 'stage-meet/order',
            href: '',
            auth: MENU_AUTH.MENU_SALES_ORDERS_PLATFORM,
          },
          {
            title: '票池订单查询', // 票池订单查询
            // href: '/sales/orders/pool',
            href: '/dealer/ticket_order_list',
            auth: MENU_AUTH.MENU_SALES_ORDERS_POOL,
            isChild: true,
            items: [
              {
                title: '票务订单详情',
                isHide: true,
                href: '/dealer/ticket_order_list/order_detail',
              },
            ],
          },
        ],
      },
      {
        title: '会员商城分析', // 会员商城分析
        href: '/sales/mall',
        auth: MENU_AUTH.MENU_SALES_MALL,
        items: [
          {
            title: '商城概览', // 商城概览
            isDev: true,
            href: '/sales/mall/overview',
            auth: MENU_AUTH.MENU_SALES_MALL_OVERVIEW,
          },
        ],
      },
    ],
  },
  {
    title: '营销中心', // 营销中心
    href: '/marketing',
    auth: MENU_AUTH.MENU_MARKETING,
    firstNav: true,
    items: [
      {
        title: '营销人群', // 营销人群
        isDev: true,
        href: '/marketing/audience',
        auth: MENU_AUTH.MENU_MARKETING_AUDIENCE,
      },
      {
        title: '营销工具', // 营销工具
        href: '/marketing/tools',
        auth: MENU_AUTH.MENU_MARKETING_TOOLS,
        items: [
          {
            title: '领券活动', // 领券活动
            // href: '/marketing/tools/pool',
            href: '/marketing/member_benefit_voucher',
            auth: MENU_AUTH.MENU_MARKETING_TOOLS_COUPON_ACT,
            isChild: true,
            items: [
              {
                title: '新建活动',
                isHide: true,
                href: '/marketing/member_benefit_voucher/add',
              },
              {
                title: '编辑活动',
                isHide: true,
                href: '/marketing/member_benefit_voucher/edit',
              },
              {
                title: '活动详情',
                isHide: true,
                href: '/marketing/member_benefit_voucher/detail',
              },
              {
                title: '小程序码',
                isHide: true,
                href: '/marketing/member_benefit_voucher/qr_code',
              },
            ],
          },
          {
            title: '复购营销', // 复购营销
            // href: '/marketing/tools/repurchase',
            href: '/marketing/scene',
            auth: MENU_AUTH.MENU_MARKETING_TOOLS_REPURCHASE,
            isChild: true,
            items: [
              {
                title: '电商渠道触达',
                href: '/marketing/scene/ec_channels_reach',
                isHide: true,
              },
              {
                title: '会员复购',
                href: '/marketing/scene/repurchase',
                isHide: true,
              },
              {
                title: '节日营销', //节日营销
                href: '/marketing/scene/festival',
                isHide: true,
              },
              {
                title: '会员注册营销', //会员注册营销
                href: '/marketing/scene/registration',
                isHide: true,
              },
              {
                title: '生日营销', //生日营销
                href: '/marketing/scene/birthday',
                isHide: true,
              },
              {
                title: '会员日营销', //会员日营销
                href: '/marketing/scene/member',
                isHide: true,
              },
              {
                title: '会员绑定', //会员绑定
                href: '/marketing/scene/bind',
                isHide: true,
              },
              {
                title: '会员消费', //会员消费
                href: '/marketing/scene/consumption',
                isHide: true,
              },
              {
                title: '等级变更', //等级变更
                href: '/marketing/scene/level_change',
                isHide: true,
              },
              {
                title: '活动数据', //活动数据
                href: '/marketing/scene/activity-view',
                isHide: true,
              },
              {
                title: '积分使用', //积分使用
                href: '/marketing/scene/point_use',
                isHide: true,
              },
              {
                title: '电商渠道触达',
                href: '/marketing/scene/ec_channels_reach_detail',
                isHide: true,
              },
              {
                title: '节日营销', //节日营销
                href: '/marketing/scene/festival_detail',
                isHide: true,
              },
              {
                title: '会员注册营销', //会员注册营销
                href: '/marketing/scene/registration_detail',
                isHide: true,
              },
              {
                title: '生日营销', //生日营销
                href: '/marketing/scene/birthday_detail',
                isHide: true,
              },
              {
                title: '会员日营销', //会员日营销
                href: '/marketing/scene/member_detail',
                isHide: true,
              },
              {
                title: '会员绑定', //会员绑定
                href: '/marketing/scene/bind_detail',
                isHide: true,
              },
              {
                title: '会员消费', //会员消费
                href: '/marketing/scene/consumption_detail',
                isHide: true,
              },
              {
                title: '等级变更', //等级变更
                href: '/marketing/scene/level_change_detail',
                isHide: true,
              },
              {
                title: '积分使用', //积分使用
                href: '/marketing/scene/point_use_detail',
                isHide: true,
              },
              {
                title: '会员复购', //积分使用
                href: '/marketing/scene/repurchase_detail',
                isHide: true,
              },
            ],
          },
          {
            title: '抽奖活动', // 抽奖活动
            // href: '/marketing/tools/lottery',
            href: '/marketing/luck_draw_view',
            auth: MENU_AUTH.MENU_MARKETING_TOOLS_LOTTERY,
            isChild: true,
            items: [
              {
                title: '新建活动',
                isHide: true,
                href: '/marketing/luck_draw_view/luck_draw_view_setting_add',
              },
              {
                title: '编辑活动',
                isHide: true,
                href: '/marketing/luck_draw_view/luck_draw_view_setting_edit',
              },
              {
                title: '活动详情',
                isHide: true,
                href: '/marketing/luck_draw_view/luck_draw_view_setting_detail',
              },
              {
                title: '小程序码',
                isHide: true,
                href: '/marketing/luck_draw_view/qr_code',
              },
              {
                title: '活动分析',
                isHide: true,
                href: '/marketing/luck_draw_view/luck_draw_view_report',
              },
            ],
          },
          {
            title: '取数工具', // 取数工具
            // href: '/marketing/tools/extract',
            href: '/data_tools/activity',
            auth: MENU_AUTH.MENU_MARKETING_TOOLS_EXTRACT,
          },
          {
            title: '分享抽奖', // 分享抽奖
            isDev: true,
            href: '/marketing/tools/share_lottery',
            auth: MENU_AUTH.MENU_MARKETING_TOOLS_SHARE_LOTTERY,
          },
          {
            title: '活动聚合页', // 活动聚合页
            isDev: true,
            href: '/marketing/tools/aggregation',
            auth: MENU_AUTH.MENU_MARKETING_TOOLS_AGGREGATION,
          },
          {
            title: '调查问卷', // 调查问卷
            isDev: true,
            href: '/marketing/tools/survey',
            auth: MENU_AUTH.MENU_MARKETING_TOOLS_SURVEY,
          },
          {
            title: '活动分析', // 活动分析
            // href: '/marketing/tools/analysis',
            href: '/marketing/account_activity_manage',
            auth: MENU_AUTH.MENU_MARKETING_TOOLS_ANALYSIS,
            isChild: true,
            items: [
              {
                title: '活动详情',
                href: '/marketing/account_activity_detail',
                isHide: true,
              },
              {
                title: '活动分析',
                href: '/marketing/account_activity_manage/analyse',
                isHide: true,
              },
            ],
          },
        ],
      },
      {
        title: '广告推广', // 广告推广
        isDev: true,
        href: '/marketing/ads',
        auth: MENU_AUTH.MENU_MARKETING_ADS,
      },
      {
        title: '渠道码管理', // 渠道码管理
        href: '/marketing/channel',
        auth: MENU_AUTH.MENU_MARKETING_CHANNEL,
        items: [
          {
            title: '生成渠道码', // 生成渠道码
            // href: '/marketing/channel/gen',
            href: '/miniapps/qr_code',
            auth: MENU_AUTH.MENU_MARKETING_CHANNEL_GEN,
            isChild: true,
            items: [
              {
                title: '新建小程序码',
                isHide: true,
                href: '/miniapps/qr_code/qr_code_add',
              },
              {
                title: '编辑小程序码',
                isHide: true,
                href: '/miniapps/qr_code/qr_code_edit',
              },
              {
                title: '小程序码详情',
                href: '/miniapps/qr_code/qr_code_detail',
              },
            ],
          },
          {
            title: '渠道数据追踪', // 渠道数据追踪
            isDev: true,
            href: '/marketing/channel/track',
            auth: MENU_AUTH.MENU_MARKETING_CHANNEL_TRACK,
          },
        ],
      },
      {
        title: '优惠券中心', // 优惠券中心
        href: '/marketing/coupons',
        auth: MENU_AUTH.MENU_MARKETING_COUPONS,
        items: [
          {
            title: '优惠券管理', // 优惠券管理
            // href: '/marketing/coupons/manage',
            href: '/coupon/coupon_list',
            auth: MENU_AUTH.MENU_MARKETING_COUPONS_MANAGE,
            isChild: true,
            items: [
              {
                title: '满减券', //满减券
                href: '/coupon/coupon_list/cash',
                isHide: true,
              },
              {
                title: '免票券',
                href: '/coupon/coupon_list/free_pass',
                isHide: true,
              },
              {
                title: '折扣券', //折扣券
                href: '/coupon/coupon_list/discount',
                isHide: true,
              },
              {
                title: '兑换券', //兑换券
                href: '/coupon/coupon_list/exchange',
                isHide: true,
              },
              {
                title: '礼品券', //兑换券
                href: '/coupon/coupon_list/gift',
                isHide: true,
              },
              {
                title: '团购券',
                href: '/coupon/coupon_list/group',
                isHide: true,
              },
              {
                title: '满折券', //满折券
                href: '/coupon/coupon_list/full-discount',
                isHide: true,
              },
              {
                title: '三方券',
                href: '/coupon/coupon_list/third',
                isHide: true,
              },
              {
                title: '三方礼品券',
                href: '/coupon/coupon_list/third_gift',
                isHide: true,
              },
              {
                title: '优惠券详情',
                href: '/coupon/coupon_list/coupon-detail',
                isHide: true,
              },
            ],
          },
          {
            title: '优惠券发放', // 优惠券发放
            // href: '/marketing/coupons/issue',
            href: '/coupon/coupon_issuance',
            auth: MENU_AUTH.MENU_MARKETING_COUPONS_ISSUE,
            isChild: true,
            items: [
              {
                title: '新建任务',
                href: '/coupon/coupon_issuance/add',
                isHide: true,
              },
            ],
          },
          {
            title: '优惠券核销', // 优惠券核销
            // href: '/marketing/coupons/verify',
            href: '/coupon/coupon_use',
            auth: MENU_AUTH.MENU_MARKETING_COUPONS_VERIFY,
          },
          {
            title: '优惠券数据', // 优惠券数据
            // href: '/marketing/coupons/data',
            href: '/coupon/coupon_data',
            auth: MENU_AUTH.MENU_MARKETING_COUPONS_DATA,
          },
          {
            title: '兑换券核销部门', // 兑换券核销部门
            // href: '/marketing/coupons/exchange_verify_dept',
            href: '/coupon/redemption_voucher_verification_department',
            auth: MENU_AUTH.MENU_MARKETING_COUPONS_EXCHANGE_VERIFY_DEPT,
            isChild: true,
            items: [
              {
                title: '新建',
                href: '/coupon/redemption_voucher_verification_department/add',
                isHide: true,
              },
              {
                title: '编辑',
                href: '/coupon/redemption_voucher_verification_department/edit',
                isHide: true,
              },
              {
                title: '详情',
                href: '/coupon/redemption_voucher_verification_department/detail',
                isHide: true,
              },
            ],
          },
          {
            title: '兑换券核销人员', // 兑换券核销人员
            // href: '/marketing/coupons/exchange_verify_employee',
            href: '/coupon/redemption_voucher_verification_employee',
            auth: MENU_AUTH.MENU_MARKETING_COUPONS_EXCHANGE_VERIFY_EMPLOYEE,
          },
        ],
      },
      {
        title: '触达管理', // 触达管理
        href: '/marketing/reach',
        auth: MENU_AUTH.MENU_MARKETING_REACH,
        items: [
          {
            title: '小程序推送', // 小程序推送
            // href: '/marketing/reach/mp',
            href: '/miniapps/template_list',
            auth: MENU_AUTH.MENU_MARKETING_REACH_MP,
            isChild: true,
            items: [
              {
                title: '新建订阅消息',
                href: '/miniapps/template_list/addWmpTemplate',
                isHide: true,
              },
              {
                title: '编辑订阅消息',
                href: '/miniapps/template_list/editWmpTemplate',
                isHide: true,
              },
            ],
          },
          {
            title: '短信发送', // 短信发送
            isDev: true,
            href: '/marketing/reach/sms',
            auth: MENU_AUTH.MENU_MARKETING_REACH_SMS,
          },
        ],
      },
    ],
  },
  {
    title: '会员中心', // 会员中心
    href: '/members',
    auth: MENU_AUTH.MENU_MEMBERS,
    firstNav: true,
    items: [
      {
        title: '会员管理', // 会员管理
        href: '/members/manage',
        auth: MENU_AUTH.MENU_MEMBERS_MANAGE,
        items: [
          {
            title: '会员管理(积分管理)', // 积分管理
            // href: '/members/manage/points',
            href: '/dealer-customer/mm',
            auth: MENU_AUTH.MENU_MEMBERS_MANAGE_POINTS,
            isChild: true,
            items: [
              {
                title: '会员管理详情',
                // href: '/members/manage/points/detail',
                href: '/dealer-customer/mm/ml',
                isHide: true,
              },
            ],
          },
          {
            title: '会员查询', // 会员查询
            // href: '/members/manage/query',
            href: '/dealer-customer/emp_search',
            auth: MENU_AUTH.MENU_MEMBERS_MANAGE_QUERY,
            isChild: true,
            items: [
              {
                title: '会员详情',
                href: '/dealer-customer/emp_search/detail',
                isHide: true,
              },
            ],
          },
          {
            title: '会员调整', // 会员调整
            // href: '/members/manage/adjust',
            href: '/adjust/adjust_list',
            auth: MENU_AUTH.MENU_MEMBERS_MANAGE_ADJUST,
            isChild: true,
            items: [
              {
                title: '会员解绑',
                href: '/adjust/adjust_list/unbind_member',
                isHide: true,
              },
              {
                title: '会员解绑详情',
                href: '/adjust/adjust_list/unbind_member_detail',
                isHide: true,
              },
              {
                title: '会员编辑',
                href: '/adjust/adjust_list/edit',
                isHide: true,
              },
              {
                title: '优惠券',
                href: '/adjust/adjust_list/patch_coupon',
                isHide: true,
              },
              {
                title: '等级调整',
                href: '/adjust/adjust_list/changeLevel',
                isHide: true,
              },
              {
                title: '积分调整',
                href: '/adjust/adjust_list/changeIntegral',
                isHide: true,
              },
              {
                title: '卡号合并',
                href: '/adjust/adjust_list/card_merge',
                isHide: true,
              },
              {
                title: '批量调整',
                href: '/adjust/adjust_list/adjust_many',
                isHide: true,
              },
            ],
          },
        ],
      },
      {
        title: '会员行为', // 会员行为
        href: '/members/behavior',
        auth: MENU_AUTH.MENU_MEMBERS_BEHAVIOR,
        items: [
          {
            title: '会员看板', // 会员看板
            // href: '/members/behavior/board',
            href: '/ec/dashboard',
            auth: MENU_AUTH.MENU_MEMBERS_BEHAVIOR_BOARD,
          },
          {
            title: '会员分析', // 会员分析
            // href: '/members/behavior/analysis',
            href: '/cm/emp_analysis',
            auth: MENU_AUTH.MENU_MEMBERS_BEHAVIOR_ANALYSIS,
          },
          {
            title: '会员权益使用', // 会员权益使用
            isDev: true,
            href: '/members/behavior/benefit',
            auth: MENU_AUTH.MENU_MEMBERS_BEHAVIOR_BENEFIT,
          },
        ],
      },
      {
        title: '用户标签', // 用户标签
        href: '/members/tags',
        auth: MENU_AUTH.MENU_MEMBERS_TAGS,
        items: [
          {
            title: '标签库和数据', // 标签库和数据
            // href: '/members/tags/manage',
            href: '/profile/label_manage',
            auth: MENU_AUTH.MENU_MEMBERS_TAGS_MANAGE,
            isChild: true,
            items: [
              {
                title: '集合类标签',
                href: '/profile/label_manage/collection_label',
                isHide: true,
              },
              {
                title: 'SQL标签',
                href: '/profile/label_manage/sql',
                isHide: true,
              },
              {
                title: '导入标签',
                href: '/profile/label_manage/import',
                isHide: true,
              },
              {
                title: '统计类标签',
                href: '/profile/label_manage/statistics',
                isHide: true,
              },
              {
                title: '集合类标签',
                href: '/profile/label_manage/collection_label_edit',
                isHide: true,
              },
              {
                title: 'SQL标签',
                href: '/profile/label_manage/sql_edit',
                isHide: true,
              },
              {
                title: '导入标签',
                href: '/profile/label_manage/import_edit',
                isHide: true,
              },
              {
                title: '统计类标签',
                href: '/profile/label_manage/statistics_edit',
                isHide: true,
              },
              {
                title: '集合类标签',
                href: '/profile/label_manage/collection_label_detail',
                isHide: true,
              },
              {
                title: 'SQL标签',
                href: '/profile/label_manage/sql_detail',
                isHide: true,
              },
              {
                title: '导入标签',
                href: '/profile/label_manage/import_detail',
                isHide: true,
              },
              {
                title: '统计类标签',
                href: '/profile/label_manage/statistics_detail',
                isHide: true,
              },
            ],
          },
          {
            title: '用户人群圈选', // 用户人群圈选
            // href: '/members/tags/crowd',
            href: '/profile/crowd_manage',
            auth: MENU_AUTH.MENU_MEMBERS_TAGS_CROWD,
            isChild: true,
            items: [
              {
                title: '人群画像',
                href: '/profile/crowd_manage/crowd_portrayal',
                isHide: true,
              },
              {
                title: '导入外部人群',
                href: '/profile/crowd_manage/crowd_import',
                isHide: true,
              },
              {
                title: '人群详情',
                href: '/profile/crowd_manage/crowd_detail',
                isHide: true,
              },
              {
                title: '创建人群',
                href: '/profile/crowd_manage/crowd_create',
                isHide: true,
              },
              {
                title: '编辑人群',
                href: '/profile/crowd_manage/crowd_edit',
                isHide: true,
              },
              {
                title: '详情',
                href: '/profile/crowd_manage/crowd_detail/rule_detail',
                isHide: true,
              },
            ],
          },
          {
            title: '标签目录整理', // 标签目录整理
            // href: '/members/tags/collection',
            href: '/profile/collection_label_edit',
            auth: MENU_AUTH.MENU_MEMBERS_TAGS_COLLECTION,
            isChild: true,
            items: [],
          },
        ],
      },
      {
        title: '用户积分管理', // 用户积分管理
        // href: '/members/points',
        href: '/dealer-customer/mm',
        auth: MENU_AUTH.MENU_MEMBERS_POINTS,
        isChild: true,
        items: [
          {
            title: '会员管理详情',
            href: '/dealer-customer/mm/ml',
            isHide: true,
          },
        ],
      },
      {
        title: '订单管理', // 订单管理
        // href: '/members/orders',
        href: '/cm/order_list',
        auth: MENU_AUTH.MENU_MEMBERS_ORDERS,
        isChild: true,
        items: [
          {
            title: '订单详情', //订单详情
            href: '/cm/order_list/order_detail',
            isHide: true,
          },
        ],
      },
      {
        title: '会员等级权益管理', // 会员等级权益管理
        isDev: true,
        href: '/members/levels',
        auth: MENU_AUTH.MENU_MEMBERS_LEVELS,
      },
      {
        title: '888VIP', // 888VIP
        isDev: true,
        href: '/members/vip',
        auth: MENU_AUTH.MENU_MEMBERS_VIP,
      },
      {
        title: '会员洞察', // 会员洞察
        isDev: true,
        href: '/members/insight',
        auth: MENU_AUTH.MENU_MEMBERS_INSIGHT,
        items: [
          {
            title: 'RFM分析', // RFM分析
            isDev: true,
            href: '/members/insight/rfm',
            auth: MENU_AUTH.MENU_MEMBERS_INSIGHT_RFM,
          },
        ],
      },
      {
        title: '投诉处理', // 投诉处理
        isDev: true,
        href: '/members/complaints',
        auth: MENU_AUTH.MENU_MEMBERS_COMPLAINTS,
      },
    ],
  },
  {
    title: '财务管理', // 财务管理
    href: '/finance',
    auth: MENU_AUTH.MENU_FINANCE,
    firstNav: true,
    items: [
      {
        title: '开票申请导出', // 开票申请导出
        // href: '/finance/invoice',
        href: '/data_tools/export_invoice',
        auth: MENU_AUTH.MENU_FINANCE_INVOICE,
      },
    ],
  },
  {
    title: '权限中心', // 权限中心
    href: '/permissions',
    auth: MENU_AUTH.MENU_PERMISSIONS,
    firstNav: true,
    items: [
      {
        title: '超级管理员', // 超级管理员
        isDev: true,
        href: '/permissions/admin',
        auth: MENU_AUTH.MENU_PERMISSIONS_ADMIN,
      },
      {
        title: '成员权限管理', // 成员权限管理
        isDev: true,
        href: '/permissions/roles',
        auth: MENU_AUTH.MENU_PERMISSIONS_ROLES,
      },
      {
        title: '操作日志', // 操作日志
        isDev: true,
        href: '/permissions/logs',
        auth: MENU_AUTH.MENU_PERMISSIONS_LOGS,
      },
    ],
  },
];

export const MENU_CONFIG = [
  {
    subheader: 'Management',
    items: [
      ...NEW_MENU_CONFIG,

      {
        title: '字段管理',
        cnTitle: '字段管理',
        icon: '',
        href: '/bre/fm',
        isHide: true,
        items: [
          {
            title: '系统字段',
            cnTitle: '系统字段',
            icon: ' ',
            href: '/bre/fm/cfpm',
            pageTitle: '上传文件查询',
          },
          {
            title: '临时变量',
            cnTitle: '临时变量',
            icon: ' ',
            href: '/bre/fm/tvf',
            pageTitle: '上传文件查询',
          },
        ],
      },
      {
        title: '规则引擎',
        cnTitle: '规则引擎',
        icon: '',
        href: '/bre',
        isHide: true,
        items: [
          {
            title: '规则管理',
            cnTitle: '规则管理',
            icon: ' ',
            href: '/bre/rm',

            items: [
              {
                title: '规则列表',
                cnTitle: '规则列表',
                icon: ' ',
                href: '/bre/rm/rule',
                pageTitle: '规则列表',

                items: [
                  {
                    title: '规则配置',
                    cnTitle: '规则配置',
                    icon: ' ',
                    href: '/bre/rm/rule/cfg',
                    pageTitle: '规则配置',

                    items: [
                      {
                        title: '规则测试',
                        cnTitle: '规则测试',
                        icon: ' ',
                        href: '/bre/rm/rule/cfg/c_unit_test',
                        pageTitle: '规则测试',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            title: '快捷规则管理',
            cnTitle: '快捷规则管理',
            icon: ' ',
            href: '/bre/mm',
            pageTitle: '模型管理',
          },
        ],
      },
      {
        title: '决策图管理',
        cnTitle: '决策图管理',
        icon: '',
        href: '/bre/dgm',
        isHide: true,
        items: [
          {
            icon: 'juecetuguanli',
            title: '决策图列表',
            cnTitle: '决策图列表',
            href: '/bre/dgm/dgm',
            pageTitle: '决策图列表',

            items: [
              {
                title: '决策图配置',
                cnTitle: '决策图配置',
                icon: ' ',
                href: '/bre/dgm/dgm/dgmp',
                pageTitle: '决策图配置',
              },
            ],
          },
          {
            icon: 'banben',
            title: '决策图版本管理',
            cnTitle: '决策图版本管理',
            href: '/bre/dgm/dvm',
            pageTitle: '决策图版本管理',
          },
          {
            icon: 'fuhe',
            title: '决策图复核',
            cnTitle: '决策图复核',
            href: '/bre/dgm/dr',
            pageTitle: '决策图复核',
          },
          {
            icon: 'ceshi',
            title: '决策图测试',
            cnTitle: '决策图测试',
            href: '/bre/dgm/dgt/test',
            pageTitle: '决策图测试',
          },
          {
            icon: 'record',
            title: '执行记录查询',
            cnTitle: '执行记录查询',
            href: '/bre/dgm/der',
            pageTitle: '执行记录查询',
          },
        ],
      },
      {
        title: '权限管理',
        cnTitle: '权限管理',
        icon: '',
        href: '/authority',
        // auth: MENU_AUTH.MENU_AUTH_MANAGE,
        firstNav: true,
        isHide: true,
        items: [
          {
            icon: 'menu_mm',
            title: '租户管理',
            cnTitle: '租户管理',
            href: '/authority/tenant',
            // auth: MENU_AUTH.MENU_AUTH_TENANT_MANAGE,
          },
          {
            title: '新建租户',
            cnTitle: '新建租户',
            href: '/authority/tenant/add',
            // auth: MENU_AUTH.OPT_AUTH_TENANT_MANAGE_ADD,
            isHide: true,
          },
          {
            title: '编辑租户',
            cnTitle: '编辑租户',
            href: '/authority/tenant/edit',
            // auth: MENU_AUTH.OPT_AUTH_TENANT_MANAGE_EDIT,
            isHide: true,
          },
          {
            title: '租户详情',
            cnTitle: '租户详情',
            href: '/authority/tenant/detail',
            // auth: MENU_AUTH.OPT_AUTH_TENANT_MANAGE_DETAIL,
            isHide: true,
          },
          {
            icon: 'menu_mm',
            title: '角色管理',
            cnTitle: '角色管理',
            href: '/authority/role',
            // auth: MENU_AUTH.MENU_AUTH_ROLE_MANAGE,
          },
          {
            title: '新建角色',
            cnTitle: '新建角色',
            href: '/authority/role/add',
            // auth: MENU_AUTH.OPT_AUTH_ROLE_MANAGE_ADD,
            isHide: true,
          },
          {
            title: '编辑角色',
            cnTitle: '编辑角色',
            href: '/authority/role/edit',
            // auth: MENU_AUTH.OPT_AUTH_ROLE_MANAGE_EDIT,
            isHide: true,
          },
          {
            title: '角色详情',
            cnTitle: '角色详情',
            href: '/authority/role/detail',
            // auth: MENU_AUTH.OPT_AUTH_ROLE_MANAGE_DETAIL,
            isHide: true,
          },
          {
            icon: 'menu_mm',
            title: '用户管理',
            cnTitle: '用户管理',
            href: '/authority/account_user',
            // auth: MENU_AUTH.MENU_AUTH_USER_MANAGE,
          },
          {
            title: '新建用户',
            cnTitle: '新建用户',
            href: '/authority/account_user/add',
            // auth: MENU_AUTH.OPT_AUTH_USER_MANAGE_ADD,
            isHide: true,
          },
          {
            title: '编辑用户',
            cnTitle: '编辑用户',
            href: '/authority/account_user/edit',
            // auth: MENU_AUTH.OPT_AUTH_USER_MANAGE_EDIT,
            isHide: true,
          },
          {
            title: '用户详情',
            cnTitle: '用户详情',
            href: '/authority/account_user/detail',
            // auth: MENU_AUTH.OPT_AUTH_USER_MANAGE_DETAIL,
            isHide: true,
          },
        ],
      },
    ],
  },
];
